import * as React from 'react';
import { Image, UIText2 } from '@cian/ui-kit';

import * as styles from './PromoItem.css';

interface IPromoItemProps {
  author: string;
  authorLogo: string;
  description: string;
  name: string;
  newbuildingCount: string;
  type: string;
}

export const PromoItem: React.FC<IPromoItemProps> = ({
  author,
  authorLogo,
  name,
  description,
  newbuildingCount,
  type,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['main']}>
        <div className={styles['main-content']}>
          <UIText2 color="gray60_100" display="block">
            {author}
          </UIText2>
          <UIText2 as="h3" fontWeight="bold" display="block">
            {name}
          </UIText2>
          <UIText2 display="block">{description}</UIText2>
        </div>
        <div className={styles['main-logo']}>
          <Image src={authorLogo} borderRadius="0" objectFit="contain" />
        </div>
      </div>
      <div className={styles['footer']}>
        <UIText2 color="gray60_100">{newbuildingCount}</UIText2>
        <UIText2 color="gray60_100">{type}</UIText2>
      </div>
    </div>
  );
};
